import React from 'react'
import Main from '../BuyNowCheckout/Main'

export const BuynowCheckout = () => {
  return (
    <>
    <Main/>
    </>
  )
}
